import { type PickMember, formatDate, personPickLine } from '@splitfiesta/core';
import { useTranslation } from '@splitfiesta/i18n';
import type { ExpenseResponseDto } from '@splitfiesta/shared';

interface PersonPickLineProps {
  expense: ExpenseResponseDto;
  userId: string;
  members: readonly PickMember[];
  /** Everyone has picked; the page works it out once for all rows. */
  done: boolean;
}

/** The second line of a split row once the table was asked; nothing for a placeholder. */
export function PersonPickLine({
  expense,
  userId,
  members,
  done,
}: PersonPickLineProps) {
  const { t, i18n } = useTranslation('expenses');
  const line = personPickLine(expense, userId, members);
  if (line.state === 'noApp') return null;

  let text: string;
  if (line.state === 'notYet') {
    text = t('picks.line.notYet');
  } else if (done) {
    text = t('picks.line.tipIncluded', { count: line.items });
  } else {
    text = t('picks.line.withTime', {
      line: t(`picks.line.${line.source}`, { count: line.items }),
      time: formatDate(line.pickedAt, i18n.language, {
        hour: 'numeric',
        minute: '2-digit',
      }),
    });
  }

  return (
    <p
      data-testid={`person-pick-${userId}`}
      className="text-sm text-gray-500 dark:text-gray-400"
    >
      {text}
    </p>
  );
}

export default PersonPickLine;
